/**
 * Client-side slice of the workflow helpers — just the display
 * formatting the UI needs. The full workflow engine (transition
 * validation, state graphs) stays server-side; the client only
 * renders names the server already resolved.
 */

import i18n from "i18next";

/** Human-readable status name, in the language of the UI. */
export function displayStateName(name: string | null | undefined): string {
  if (!name) return "";
  const key = `workItemLabels.state.${name}`;
  if (i18n.exists(key)) return i18n.t(key);
  return name.replace(/_/g, " ");
}
